import {
    IOneVerifyReportCoverageResultData,
    IOneVerifyReportCoverageResultDataUnmapped,
} from "@common-shared/types/requestData/oneVerifyRequestData.types.ts"
import type { IPractice } from "@common-shared/types/responseData/commonResponseData.types.ts"

import { API_ROUTES } from "../config/routes.config"
import { HttpHelper } from "../helpers/http.helper"
import { UtilHelper } from "../helpers/util.helper.tsx"

export class SupportService {
    /**
     * Report coverage result by user
     */
    static async reportCoverageResult(
        data: IOneVerifyReportCoverageResultDataUnmapped,
        practice: IPractice,
    ): Promise<any> {
        const { message, coverageResult } = data

        if (!coverageResult.requestId) {
            return undefined
        }

        const requestData: IOneVerifyReportCoverageResultData = {
            message,

            coverageApiRequestId: coverageResult.requestId,
            isInNetworkCheck: coverageResult.isInNetworkCheck,
            payerExternalId: coverageResult.payer?.payerId,
            memberId: coverageResult.memberId,
        }

        const result = await HttpHelper.sendRequest(
            API_ROUTES.SUPPORT_REPORT_COVERAGE_RESULT.replace(
                ":practiceId",
                practice.id.toString(),
            ),
            requestData,
            "POST",
        )

        return result && !UtilHelper.isEmptyObject(result) && !result.errorData
            ? result
            : undefined
    }
}
